/**
 * The wind load settings carry the building box the wind pressure is applied
 * to. The seismic configuration needs the same box per storey, so it is used as
 * the default: `depth` runs along x, `width` along y.
 *
 * The wall box is preferred because it describes the bracing storeys; the roof
 * box is only a fallback for projects that carry no wall box yet.
 */
export const getBuildingDimensionsFromWindLoadSettings = (
  windLoadSettings?: WindLoadSettings,
): { x: number; y: number } | undefined => {
  const dimensions =
    windLoadSettings?.wallBuildingDimensions ?? windLoadSettings?.roofBuildingDimensions

  if (
    !dimensions ||
    typeof dimensions.depth !== 'number' ||
    typeof dimensions.width !== 'number' ||
    dimensions.depth <= 0 ||
    dimensions.width <= 0
  ) {
    return undefined
  }

  return { x: dimensions.depth, y: dimensions.width }
}
